/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type USER_STATUS = "ACTIVE" | "BANNED" | "PREMOD" | "SUSPENDED" | "WARNED" | "%future added value";
export type AllCommentsTabContainer_viewer = {
    readonly id: string;
    readonly status: {
        readonly current: ReadonlyArray<USER_STATUS>;
    };
    readonly ignoredUsers: ReadonlyArray<{
        readonly id: string;
    }>;
    readonly inPageNotifications: {
        readonly enabled: boolean;
    };
    readonly " $fragmentRefs": FragmentRefs<"AllCommentsTabCommentContainer_viewer" | "CreateCommentReplyMutation_viewer" | "CreateCommentMutation_viewer" | "PostCommentFormContainer_viewer">;
    readonly " $refType": "AllCommentsTabContainer_viewer";
};
export type AllCommentsTabContainer_viewer$data = AllCommentsTabContainer_viewer;
export type AllCommentsTabContainer_viewer$key = {
    readonly " $data"?: AllCommentsTabContainer_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"AllCommentsTabContainer_viewer">;
};



const node: ReaderFragment = (function () {
    var v0 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any);
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "metadata": null,
        "name": "AllCommentsTabContainer_viewer",
        "selections": [
            (v0 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": "UserStatus",
                "kind": "LinkedField",
                "name": "status",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "current",
                        "storageKey": null
                    }
                ],
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "ignoredUsers",
                "plural": true,
                "selections": [
                    (v0 /*: any*/)
                ],
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "UserInPageNotificationSettings",
                "kind": "LinkedField",
                "name": "inPageNotifications",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "enabled",
                        "storageKey": null
                    }
                ],
                "storageKey": null
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "AllCommentsTabCommentContainer_viewer"
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "CreateCommentReplyMutation_viewer"
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "CreateCommentMutation_viewer"
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "PostCommentFormContainer_viewer"
            }
        ],
        "type": "User",
        "abstractKey": null
    } as any;
})();
(node as any).hash = '5d391edea16297910acb90ff5b97c8ae';
export default node;
